<div class="
pt-4 pb-4 pl-md-5 pr-md-5 masthead bg-white">
    <div class="row justify-content-between align-items-center m-0">
        <p class="mb-0 h3">
            <i class="fa mr-3 fa-cogs"></i>
            <a class="text-info" routerLink="/workflow"><strong>Workflow</strong></a>
            <i class="fa fa-angle-right text-muted mr-2 ml-2"></i>
            <span class="text">{{countryName}}</span>
        </p>
        <div>
            <button class="btn btn-primary btn-sm ml-2" (click)="saveWorkflow()">
                Save changes <i class="fa fa-check ml-2"></i>
            </button>

        </div>
    </div>
</div>


<div class="container mt-5">
    <div class="alert alert-info mb-5" *ngIf="!workflow.canBeConfigured">
        <strong><span class="fa fa-pencil mr-2"></span>Workflow steps cannot be created, re-ordered or removed.</strong>
        {{countryName}} content is currently under review.
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="row">
                <div class="col">

                    <h3 class="h3 mb-4">
                        Manage workflow
                    </h3>

                </div>
                <div class="col col-auto text-right">

                    <button class="btn btn-sm btn-outline-secondary" (click)="applyDefaultWorkflow()"
                        [hidden]="!hasDefaultWorkflowConfiguration || (workflow.workflowStages.length != 0)"
                        [disabled]="!workflow.canBeConfigured">
                        Apply default workflow <i class="fa fa-cogs ml-2"></i>
                    </button>
                    <button class="btn btn-sm btn-primary ml-2" (click)="addStep()"
                        [disabled]="!workflow.canBeConfigured">
                        Create new step
                    </button>

                </div>
            </div>
            <div class="row mt-3" *ngIf=" workflow.workflowStages.length == 0">
                <div class="col">
                    <div class="alert alert-info">
                        <em>
                            There are currently no steps setup for this location.
                        </em>
                    </div>
                </div>
            </div>
            <ul class="draggable mt-3" cdkDropList [cdkDropListData]="workflow.workflowStages" (cdkDropListDropped)="drop($event)" [cdkDropListDisabled]="!workflow.canBeConfigured">
                <li *ngFor="let step of workflow.workflowStages; trackBy: trackByStepId"
                    class="draggable-item mt-2 mb-4 item-depth--1" 
                    cdkDrag 
                    [cdkDragData]="step"
                    [cdkDragDisabled]="step.disabled || !workflow.canBeConfigured"
                    [ngClass]="{'draggable-item-disabled': step.disabled, 'ignore-item': !workflow.canBeConfigured}">
                    <div class="card mb-3">
                        <div class="row ml-0 mr-0 align-items-center">
                            <div cdkDragHandle title="Drag to reorder steps" class="d-flex align-items-center ml-2">
                                <div class="drag-handle me-1">
                                    <i class="fa fa-bars"></i>
                                </div>
                            </div>
                            <div class="col draggable-content pl-1">
                                <div class="input-group">
                                    <input type="text" class="form-control  border-0" [value]="title"
                                        [(ngModel)]="step.name" required [disabled]="step.disabled" />
                                </div>
                            </div>
                            <i class="fa fa-close ml-2 p-3 text-info"
                                *ngIf="!step.disabled && workflow.canBeConfigured" (click)="stepDeleted(step)"
                                title="Disable step" role="button"></i>
                            <i class="fa fa-undo ml-2 p-3 text-info"
                                *ngIf="step.disabled && workflow.canBeConfigured" (click)="stepEnabled(step)"
                                role="button" title="Enable step"></i>
                        </div>
                    </div>

                    <div class="ml-5 mr-3 mb-2">
                        <div *ngFor="let sec of step.security" class="mb-2 d-flex justify-content-between">
                            <small>
                                <i class="fa mr-2"
                                    [ngClass]="sec.email ? 'fa-user' : 'fa-group'"></i><strong>{{sec.name}}</strong>
                                <em *ngIf="sec.email">({{sec.email}})</em>
                            </small>
                            <i (click)="removeUser(step, sec)" class="fa fa-close ml-1 text-info" role="button"
                                title="Remove user"></i>
                        </div>

                        <div class="" *ngIf="step.security.length < 1">
                            <small><em class="text-muted">No users configured for this step</em></small>
                        </div>
                    </div>
                    <div class="btn btn-sm btn-primary ml-5 mt-1"
                        (click)="stepSelected(step);usersearchmodal.openModal();" title="Add users">
                        Add users <i class="fa fa-plus ml-2"></i>
                    </div>
                </li>
            </ul>

        </div>
    </div>
</div>
<confirmationmodal #confirmModal (onAccept)="onAccept();" (onDecline)="onDecline();"></confirmationmodal>
<usersearchmodal #usersearchmodal [(existingUserList)]="selectedStep.security" [(containerName)]="selectedStep.name"
    [includeGroups]="true"></usersearchmodal>
